/**
 * 原生开户
 * 目前适用于随手记
 */
import useragent from '@common/useragent'
import { call, uriSuishouji, uriSuiguanjia } from './bridge'

/**
 * callback: 开户完成的回调函数
 */
export default (state = 1) => {
  if (useragent.isSuishouji) {
    call(uriSuishouji('updateOpenAccountState', {
      state
    }))
  } else if (useragent.isSuiguanjia) {
    call(uriSuiguanjia('sgj://app/refreshAccountStatus'))
  }
}



// WEBPACK FOOTER //
// ./node_modules/@common/client/src/updateOpenAccountState.js